import { observer } from 'mobx-react-lite';
import { Box, FormCardSection, MaskedInput, Select } from '/src/components';
import { User } from '/src/lib/models';
import { FormErrors, SalesCommissionDataForm } from '/src/lib/types';

export type SalesCommissionsProps = {
  id?: string;
  commissions: SalesCommissionDataForm[];
  setCommissions: (values: SalesCommissionDataForm[]) => void;
  formErrors: Record<string, FormErrors>;
  users: User[];
};

export const SalesCommissions: React.FC<SalesCommissionsProps> = observer((props) => {
  const { id, commissions, setCommissions, formErrors } = props;

  /** Methods **/
  const updateFormValue = (key: keyof SalesCommissionDataForm, index: number, value: unknown) => {
    const updatedValues = [...commissions];
    updatedValues[index] = {
      ...updatedValues[index],
      [key]: value,
    };
    setCommissions(updatedValues);
    formErrors[index] ??= {} as FormErrors;
    if (formErrors[index][key]) formErrors[index][key] = '';
  };

  /** Render **/
  return (
    <FormCardSection id={id} title="Sales Commissions">
      {commissions.map((commission, index) => (
        <Box row gap="1rem" key={index}>
          <Select
            id="user_id"
            label="Salesperson"
            value={commission.user_id}
            setValue={(value) => updateFormValue('user_id', index, value)}
            options={
              props.users
                ?.filter((user) => [977, 22, 53, 58, 1175, 7, 10].includes(user.id))
                .map((user: User) => ({ label: user.name, value: user.id })) || []
            }
            error={formErrors[index]?.['user_id']}
            fill="horizontal"
          />
          <MaskedInput
            id="sales_commission_percent_rate"
            label="Commission Percent (%)"
            value={commission.percent_rate}
            setValue={(value) => updateFormValue('percent_rate', index, value)}
            error={formErrors[index]?.['percent_rate']}
            componentType="percent"
            isActiveLabel
            fill="horizontal"
          />
        </Box>
      ))}
    </FormCardSection>
  );
});
